import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosolapurcab() {



  const cardData =
  {
    keyword: 'Pune to Solapur Cab',
    heading: 'Sai Trupti Cabs: Pune to Solapur Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Solapur cab services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Solapur. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Solapur convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Solapur with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Siddheshwar Temple",
    "description": "The Siddheshwar Temple in Solapur stands at the heart of the city, surrounded by a sacred lake and steeped in devotion. Dedicated to Lord Siddheshwar (a 12th-century saint and devotee of Shiva), the temple houses 68 carved Shivlingas and a silver-plated Nandi that glimmers in the sanctum. :contentReference[oaicite:1]{index=1} The temple’s lakeside garden invites evening strolls, prayers and quiet introspection away from the bustle. During the Gadda Yatra in January, the place transforms into a vibrant devotional fair, its rhythms echoing faith and community. Sisindheshwar Temple is more than a landmark — it’s the spiritual heartbeat of Solapur."
  },
  {
    "title": "Bhuikot Fort",
    "description": "Bhuikot Fort is one of Solapur’s most impressive historic structures, perched beside the Siddheshwar Lake and extending its ramparts into the city skyline. :contentReference[oaicite:2]{index=2} Built initially by the Bahmani dynasty and later held by Mughals, Adilshahi and Marathas, the fort’s layered history is etched into its weathered walls and gateways. Visitors wander through ruins, ancient mosques, and hidden bastions that once echoed the tram of soldiers. The vantage points reveal sprawling views of Solapur’s fields and urban sprawl. As the sun sets, the stone turns golden — and the fort reminds you of the city’s legacy of power, trade and resilience."
  },
  {
    "title": "Great Indian Bustard Sanctuary (Nannaj)",
    "description": "About 22 km from the city, the Great Indian Bustard Sanctuary at Nannaj is a silent wilderness where one of India’s rarest birds — the great Indian bustard — struts across semi-arid grasslands. :contentReference[oaicite:3]{index=3} Early morning mist, dry grasses, and bird-calls create a surreal atmosphere for nature lovers and photographers alike. The open plains that surround Solapur’s farmland contrast sharply with the gentle hum of city life. With luck and patience you might spot the bustard or eagles gliding overhead. This sanctuary offers a rare escape from urban pace into nature’s measured calm."
  },
  {
    "title": "Ujjani Dam & Kambar Lake",
    "description": "Ujjani Dam and its reservoir create a refreshing counter-rhythm to Solapur’s warm plains. Evening light dances across the water, and the cool breeze offers relief after a city day. :contentReference[oaicite:4]{index=4} Nearby Kambar Lake (also called Moti Baug Tank) is a favourite among locals for bird-watching, boating and quiet walks along the embankments. The broader area invites picnics, sunsets and unhurried conversation. For travellers, it’s a place to pause, reflect and breathe."
  },
  {
    "title": "Mallikarjuna & Jain Temples",
    "description": "Solapur’s religious diversity shines at the Mallikarjuna Jain Temple and other ancient Jain shrines dotted in the district. :contentReference[oaicite:5]{index=5} The elegant stone carvings, quiet courtyards and devotional calm offer a distinct contrast to more crowded pilgrimage sites. Here, devotees and tourists alike step into stone halls, let the whisper of chants wash over them, and feel connected to centuries of faith and community. It’s an under-explored facet of Solapur’s identity — spiritual, architectural and serene."
  },
  {
    "title": "Solapur Science Centre & Urban Round-Up",
    "description": "For a curious mind, the Solapur Science Centre provides interactive exhibits, planetarium shows and a refreshing break from typical heritage walks. :contentReference[oaicite:6]{index=6} Located within city limits, it makes a great stop for families, children and anyone who wants to combine learning with travel. Nearby shopping lanes, local food stalls serving Solapuri chaddar textiles and spicy Maharashtrian snacks complete the urban experience. In Solapur, heritage and modern life sit side-by-side — both calling for a little discovery."
  },
  {
    "title": "Karmala & Akkalkot Pilgrimage Routes",
    "description": "Beyond the city’s core, places like Karmala (with its Kamaladevi temple) and Akkalkot (home of Swami Samarth) open up spiritual day-trips from Solapur. :contentReference[oaicite:9]{index=9} These less-traveled routes lead through quiet villages, fields of sugarcane and barley, and peaceful temples filled with devotion more than crowd. The green-gold plains and horizon-wide skies make the journey as memorable as the destination. When in Solapur, carve out time for both the city and its sacred outskirts."
  },
  {
    "title": "Saraf Katta Market & Local Textiles",
    "description": "No visit to Solapur is complete without strolling through Saraf Katta, the bustling textile and jewellery market in the heart of town. :contentReference[oaicite:10]{index=10} Here, colourful Solapuri chaddars, ornate sarees and local handicrafts fill the shelves, and bargaining is part of the rhythm. The fragrance of street-food, the chatter of vendors and the glint of gold in shop windows create a vivid impression of urban Maharashtra. It’s a lively contrast to the temples and forts — showcasing Solapur’s living culture, trade and everyday heartbeat."
  },
  {
    "title": "Asar Mahal & Gol Gumbad",
    "description": "The Asar Mahal and the Gol Gumbad are fine examples of Solapur’s medieval heritage — the Hall of Justice (Asar Mahal) once served as the royal court, while Gol Gumbad (the ‘Rose Dome’) showcases Islamic architecture and art. :contentReference[oaicite:11]{index=11} Wandering through the arched courtyards and dome-topped halls, you sense the convergence of faith, power and aesthetics. The stones tell stories of sultans, meeting-halls and daily court life. For history lovers, these monuments are quiet treasures in Solapur’s heritage map."
  },
  {
    "title": "Pandharpur & Vitthal-Rukmini Temple (Nearby)",
    "description": "Though technically outside the city, the pilgrimage town of Pandharpur (on the Bhima River) is closely linked to Solapur’s spiritual geography — especially for devotees of Lord Vitthal and Rukmini. :contentReference[oaicite:13]{index=13} Visiting here connects the dots between Solapur’s urban pulse and the larger Yatra tradition of Maharashtra. On Ekadashi days the town comes alive with processions, music and devotion. For a deeper journey, Solapur is a comfortable base for this legendary pilgrimage."
  }
],



"services": [
  {
    "name": "Pune to Solapur Cab",
    "description": "Book comfortable Pune to Solapur cabs for a safe, hassle-free journey. Choose from AC and non-AC vehicles including Sedans, SUVs, and luxury cars. Travel with experienced drivers familiar with long-distance routes, enjoy flexible pickup and drop points, and benefit from transparent pricing. Perfect for family trips, weekend getaways, group travel, or corporate journeys, with easy online booking, instant confirmation, and 24/7 support ensuring a smooth ride."
  },
  {
    "name": "Pune to Solapur Taxi Service",
    "description": "Hire a Pune to Solapur taxi for a stress-free and scenic journey. Well-maintained vehicles, courteous drivers, and flexible schedules make it ideal for tourists, business travelers, and families. One-way or round-trip options are available with transparent fare policies."
  },
  {
    "name": "Pune to Solapur Car Hire",
    "description": "Rent a car from Pune to Solapur for personalized and comfortable travel. Choose from Sedans, SUVs, and luxury vehicles with AC/non-AC options. Benefit from professional drivers, luggage assistance, flexible routes, and safe travel. Ideal for families, groups, or business trips seeking convenience and comfort."
  },
  {
    "name": "AC Cab Pune to Solapur",
    "description": "Travel comfortably with AC cab service from Pune to Solapur. Enjoy clean, air-conditioned vehicles, skilled drivers, flexible pickup points, and smooth, safe travel. Suitable for families, couples, and solo travelers looking for a relaxed long-distance journey."
  },
  {
    "name": "Non AC Cab Pune to Solapur",
    "description": "Affordable non-AC cab service from Pune to Solapur for budget-conscious travelers. Reliable drivers, well-maintained cars, and flexible pickup/drop points ensure safe, comfortable, and economical travel over long distances."
  },
  {
    "name": "Innova Cab Pune to Solapur",
    "description": "Book spacious and comfortable Innova cabs from Pune to Solapur. Ideal for families or groups, featuring AC comfort, ample legroom, luggage space, and experienced drivers. Enjoy smooth travel on highways and city roads for a stress-free journey."
  },
  {
    "name": "Ertiga Cab Pune to Solapur",
    "description": "Affordable and convenient group travel with Ertiga cabs from Pune to Solapur. AC/non-AC options, comfortable seating, luggage space, and professional drivers ensure a safe and enjoyable ride. Perfect for friends, families, or corporate groups."
  },
  {
    "name": "Luxury Cab Pune to Solapur",
    "description": "Travel in style with luxury cab services from Pune to Solapur. Premium Sedans and SUVs with elegant interiors, AC service, and professional chauffeurs make it ideal for VIP guests, business executives, or special occasions. Experience comfort, safety, and prestige throughout the journey."
  },
  {
    "name": "Affordable Cab Pune to Solapur",
    "description": "Get pocket-friendly Pune to Solapur cab services with transparent fares, AC/non-AC options, and professional drivers. Flexible timings, easy booking, and reliable service make it perfect for solo travelers, students, and small families looking for value-for-money travel."
  },
  {
    "name": "Pune to Solapur Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Solapur ideal for weekend trips, sightseeing, or long stays. Choose from a variety of vehicles, enjoy AC/non-AC comfort, flexible bookings, and safe travel with experienced drivers for a hassle-free interstate journey."
  },
  {
    "name": "Pune to Solapur One Way Cab",
    "description": "Book one-way cabs from Pune to Solapur at affordable rates. Point-to-point travel, clean vehicles, professional drivers, and flexible pickups make it ideal for travelers heading to Solapur without return plans."
  },
  {
    "name": "Pune to Solapur Drop Cab",
    "description": "One-way drop cab service from Pune to Solapur with flexible timings, AC/non-AC options, and professional drivers. Enjoy a smooth, comfortable ride perfect for single transfers, business trips, or leisure travel."
  },
  {
    "name": "Corporate Cab Pune to Solapur",
    "description": "Premium corporate cab hire from Pune to Solapur with executive vehicles, professional chauffeurs, and flexible travel schedules. Ideal for conferences, business meetings, client visits, and corporate events, offering comfort, punctuality, and reliability."
  },
  {
    "name": "Wedding Cab Pune to Solapur",
    "description": "Elegant wedding cab service from Pune to Solapur with luxury interiors, AC comfort, professional drivers, and on-time pickups. Perfect for bride/groom transfers, guest transport, and event logistics with complete reliability and style."
  },
  {
    "name": "Online Cab Booking Pune to Solapur",
    "description": "Book your Pune to Solapur cab online with instant confirmation, secure payment, and transparent fares. Choose from Sedans, Innova, and Ertiga for a convenient, stress-free journey. Ideal for last-minute travel, weekend trips, or planned travel with complete convenience."
  }
],
"tableData": [
  ["Pune to Solapur Cab", "Pune to Solapur Taxi Service"],
  ["Pune to Solapur Car Hire", "AC Cab Pune to Solapur"],
  ["Non AC Cab Pune to Solapur", "Innova Cab Pune to Solapur"],
  ["Ertiga Cab Pune to Solapur", "Luxury Cab Pune to Solapur"],
  ["Affordable Cab Pune to Solapur", "Pune to Solapur Outstation Cab"],
  ["Pune to Solapur One Way Cab", "Pune to Solapur Drop Cab"],
  ["Online Cab Booking Pune to Solapur", "Corporate Cab Pune to Solapur"],
  ["Wedding Cab Pune to Solapur", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Solapur Cabs",
    "WhyChoosedescription": "Sai Trupti Cabs offers safe and comfortable cab services from Pune to Solapur — perfect for family travel, business trips, temple visits, or weekend journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy affordable and transparent fares for Pune to Solapur cabs — no hidden charges, no surge pricing, and total value for your money."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars according to your comfort, group size, and budget for the Pune–Solapur route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and experienced drivers are well-versed with the Pune to Solapur route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune — airport, home, office, or railway station — and drop-offs at your preferred destination in Solapur."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "Sai Trupti Cabs maintains clean, sanitized, and regularly serviced vehicles to guarantee a comfortable and worry-free ride every time."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our friendly support team is available 24/7 to help you with bookings, route details, or any travel assistance for your Pune to Solapur cab trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Solapur cab easily through a call, WhatsApp, or our website — get instant confirmation and punctual cab service without any stress."
  }
]































  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer Pune to Solapur cab services?',
    answer: 'Yes, Sai Trupti Cabs provides safe, reliable, and affordable Pune to Solapur cab services for one way, round trips, and business or personal travel.',
  },
  {
    question: 'How can I book a Pune to Solapur cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Solapur cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking assistance.',
  },
  {
    question: 'What types of cabs are available from Pune to Solapur?',
    answer: 'We offer a range of well-maintained vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers—ideal for families, groups, and solo travelers.',
  },
  {
    question: 'Are the drivers experienced for Pune to Solapur routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced with the Pune–Solapur route, ensuring a comfortable and safe travel experience.',
  },
  {
    question: 'Can I book a cab for local sightseeing in and around Solapur?',
    answer: 'Of course! Sai Trupti Cabs offers local sightseeing packages in Solapur for attractions like Siddheshwar Temple, Solapur Fort, and Great Indian Bustard Sanctuary.',
  },
  {
    question: 'Is the Pune to Solapur cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs operates 24×7 Pune to Solapur cab services so you can plan your trip anytime according to your convenience.',
  },
  {
    question: 'What are the Pune to Solapur cab fares?',
    answer: 'Our Pune to Solapur cab fares start from ₹2,200 for sedans and ₹2,900–₹3,700 for SUVs or Innova Crysta, depending on your travel plan and vehicle choice.',
  },
  {
    question: 'What payment options are available for Pune to Solapur cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, digital wallets, and bank transfers for a seamless and secure transaction experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Solapur cabs?',
    answer: 'All our cabs are sanitized before each ride, and our drivers follow strict hygiene and safety protocols to ensure a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pune to Solapur cab journey?',
    answer: 'Yes, Sai Trupti Cabs provides round-the-clock customer support to assist you during your Pune to Solapur trip.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Deshmukh',
    feedback: 'Our Pune to Solapur trip with Sai Trupti Cabs was smooth and comfortable. The driver was professional and the car was clean and spacious.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Priya Patil',
    feedback: 'Highly satisfied with Sai Trupti Cabs for Pune to Solapur travel. Punctual service, safe driving, and excellent customer support.',
    rating: 5,
  },
];





























































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Solapur Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-solapur-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Solapur cab service with one way taxi, round trip cabs, sedan, SUV, Ertiga and Innova Crysta options. Book affordable outstation cabs with professional drivers, 24x7 service and safe, comfortable travel experience.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Pune to Solapur"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8650"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-solapur-cab-booking",
    "itemCondition": "https://schema.org/NewCondition"
  }
};












  return (
    <div>
<Helmet>
  <title>Pune to Solapur Cab Service | One Way Taxi ₹2199 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Solapur cab at best price ₹2199 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, fast and 24x7 cab service for daily and outstation travel." 
  />

  <meta 
    name="keywords" 
    content="pune to solapur cab, pune to solapur taxi, pune to solapur cab service, pune to solapur one way cab, pune to solapur taxi fare, pune to solapur innova crysta, pune to solapur ertiga cab, pune to solapur sedan cab, cheap pune to solapur cab, best cab service pune to solapur, pune to solapur drop taxi, pune to solapur round trip cab, outstation cab pune to solapur, pune to solapur online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/81.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetosolapurcab;